module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av388-9c7a27e885d61297444058c260ce14d0.jpg";